export default {
  login: 'Ruhulcse',
  id: 20565147,
  node_id: 'MDQ6VXNlcjIwNTY1MTQ3',
  avatar_url: 'https://avatars3.githubusercontent.com/u/20565147?v=4',
  gravatar_id: '',
  url: 'https://api.github.com/users/Ruhulcse',
  html_url: 'https://github.com/Ruhulcse',
  followers_url: 'https://api.github.com/users/Ruhulcse/followers',
  following_url: 'https://api.github.com/users/Ruhulcse/following{/other_user}',
  gists_url: 'https://api.github.com/users/Ruhulcse/gists{/gist_id}',
  starred_url: 'https://api.github.com/users/Ruhulcse/starred{/owner}{/repo}',
  subscriptions_url: 'https://api.github.com/users/Ruhulcse/subscriptions',
  organizations_url: 'https://api.github.com/users/Ruhulcse/orgs',
  repos_url: 'https://api.github.com/users/Ruhulcse/repos',
  events_url: 'https://api.github.com/users/Ruhulcse/events{/privacy}',
  received_events_url: 'https://api.github.com/users/Ruhulcse/received_events',
  type: 'User',
  site_admin: false,
  name: 'Ruhul amin',
  company: 'College of business science and technology',
  blog: 'ruhulsworld.blogspot.com',
  location: 'mymensingh,Bangladesh',
  email: null,
  hireable: true,
  bio: 'Software Engineer at Smart Field Service',
  twitter_username: null,
  public_repos: 31,
  public_gists: 5,
  followers: 15,
  following: 19,
  created_at: '2016-07-20T19:34:55Z',
  updated_at: '2020-11-01T07:34:15Z'
}